import Link from 'next/link';

import { useMediaQuery, Grid, Button } from '@material-ui/core';
import { useTheme } from '@material-ui/core/styles';

import PropTypes from 'prop-types';

import { Image } from '@/src/components/atoms';
import { SectionHeader } from '@/src/components/molecules';

const About = props => {
  const { className, onLearnMore, ...rest } = props;

  const theme = useTheme();
  const isMd = useMediaQuery(theme.breakpoints.up('md'), { defaultMatches: true });

  return (
    <div className={className} data-aos="fade-up" {...rest}>
      <Grid container justifyContent="space-between" spacing={isMd ? 4 : 0}>
        <Grid item xs={12} md={6} data-aos="fade-up">
          <Grid container spacing={2} alignItems="flex-start">
            <Grid item xs={12}>
              <SectionHeader
                title="Segurança e privacidade em primeiro lugar"
                subtitle="Nossa solução foi construída pensando na proteção dos dados dos usuários e privacidade durante sua experiência na plataforma."
                ctaGroup={[
                  <Link
                    href="/schedule?utm_campaign=security&utm_content=about"
                    passHref
                    key="scheduleCta">
                    <Button
                      aria-label="Agendar demonstração"
                      component="a"
                      variant="contained"
                      color="primary"
                      size={isMd ? 'large' : 'medium'}>
                      Agendar demonstração
                    </Button>
                  </Link>,
                  <Button
                    aria-label="Saiba mais"
                    variant="outlined"
                    color="primary"
                    size={isMd ? 'large' : 'medium'}
                    onClick={onLearnMore}
                    key="learnMoreCta">
                    Saiba mais
                  </Button>,
                ]}
                align={isMd ? 'left' : 'center'}
                disableGutter
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid item container justifyContent="center" xs={12} md={6} data-aos="fade-up">
          <Image
            src="/images/illustrations/security/hero.svg"
            alt="Segurança e privacidade"
            width="100%"
          />
        </Grid>
      </Grid>
    </div>
  );
};

About.propTypes = {
  className: PropTypes.string,
  onLearnMore: PropTypes.func,
};

export default About;
